import { render, staticRenderFns } from "./ShortVideoPlay.vue?vue&type=template&id=24386204&scoped=true"
import script from "./ShortVideoPlay.vue?vue&type=script&lang=js"
export * from "./ShortVideoPlay.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoPlay.vue?vue&type=style&index=0&id=24386204&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24386204",
  null
  
)

export default component.exports